import searchOccassionList from './searchOccassionList.json';
import packageList from './packageList.json';
import budgetMinList from './budgetMinList.json';
import budgetMaxList from './budgetMaxList.json';
import capacityMinList from './capacityMinList.json';
import capacityMaxList from './capacityMaxList.json';
import venueTypeList from './venueTypeList.json';
import minRoomsList from './roomMinList.json'
import maxRoomList from './roomMaxList.json'

export const destinationWeddingFilters = [
    {
        "keyName": "price",
        "queryParamName": "price_with_guests",
        "_id": "5c1241e9caa9a513e691c6f6",
        "params": [],
        "minParams": budgetMinList,
        "maxParams": budgetMaxList,
        "name": "price",
        "filterType": "dropDown",
        "displayName": "Budget",
        "btnWrapper": "vm-budget-filter",
        "btnIcon": "fa-circle-o",
        "selectedBtnIcon": "fa-check-circle-o",
        "minParam": "min_price_with_guests",
        "maxParam": "max_price_with_guests"
    },
    {
        "keyName": "rooms",
        "queryParamName": "room_count",
        "_id": "5c1241e9caa9a513e691c6890",
        "params": [],
        "minParams": minRoomsList,
        "maxParams": maxRoomList,
        "name": "rooms",
        "filterType": "dropDown",
        "displayName": "Rooms",
        "btnWrapper": "vm-budget-filter",
        "btnIcon": "fa-circle-o",
        "selectedBtnIcon": "fa-check-circle-o",
        "minParam": "min_room_count",
        "maxParam": "max_room_count"
    },
    {
        "keyName": "capacity",
        "queryParamName": "capacity",
        "_id": "5c1241e9caa9a513e691c6f4",
        "params": [],
        "minParams": capacityMinList,
        "maxParams": capacityMaxList,
        "name": "capacity",
        "filterType": "dropDown",
        "displayName": "Guests",
        "btnWrapper": "vm-capacity-filter",
        "btnIcon": "fa-circle-o",
        "selectedBtnIcon": "fa-check-circle-o",
        "minParam": "min_capacity",
        "maxParam": "max_capacity"
    },
    {
        "keyName": "venuetypes",
        "queryParamName": "venuetypes",
        "_id": "5c1241e9caa9a513e691c6f1",
        "params": venueTypeList,
        "name": "venuetypes",
        "filterType": "multiSelect",
        "btnIcon": "fa-square-o",
        "btnWrapper": "vm-venuetype-filter",
        "displayName": "Venue Types",
        "selectedBtnIcon": "fa-check-square-o",
        "structureType": "venuetype-link"
     },
]
